import React from "react";
import classnames from "classnames";

import "@/components/IndustryCollapsible/IndustryCollapsibleStyles.scss";
import {PropsWithChildren, ReactNode, useEffect, useRef, useState} from "react";

import {isUndefined} from "@/shared/FunctionCore";

interface IndustryCollapsibleProperties {
    header: ReactNode | string;
    iconButtonClassName: string;
    titleClassName: string;
}

const IndustryCollapsible = (props: PropsWithChildren<IndustryCollapsibleProperties>): JSX.Element => {
    const {
        children,
        header,
        iconButtonClassName,
        titleClassName
    } = props;

    const [height, setHeight] = useState<number | undefined>();
    const [isOpen, setIsOpen] = useState(false);

    const reference = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const referenceCurrent = reference.current;

        if (isUndefined(height) || !isOpen || referenceCurrent === null) {
            return void 0;
        }

        const resizeObserver = new ResizeObserver((re) => setHeight(re[0]!.contentRect.height));

        resizeObserver.observe(referenceCurrent);

        return () => resizeObserver.disconnect();
    }, [height, isOpen]);

    useEffect(() => {
        setHeight(isOpen ? reference.current?.getBoundingClientRect().height : 0);
    }, [isOpen]);

    const str = `icon-defaults ${iconButtonClassName} ${isOpen ? "rotate-center up" : "rotate-center down"}`;

    return (
        <div>
            <div className="default-ic-card">
                <div
                    className="default-ic-header"
                    onClick={() => {
                        setIsOpen((bo) => !bo);
                    }}
                >
                    <div className={titleClassName}>
                        {header}
                    </div>
                    <button className={str} type="button" />
                </div>
            </div>

            <div
                className="default-ic-content"
                style={{"height": height}}>
                <div ref={reference}>
                    <div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export {IndustryCollapsible};
